import React from 'react';
import TopBarLeft from './TopBarLeft';
import TopbarRight from './TopBarRight';

type TopbarProps = {
    onStartPrint: () => void;
    org: any;
    showOrgMenu: boolean;
    setShowOrgMenu: (value: boolean | ((prev: boolean) => boolean)) => void;
    orgDropdownRef: React.RefObject<HTMLDivElement>;
    changeOrganization: (org: any) => void | Promise<void>;
    currentUser: any;
    showUserMenu: boolean;
    setShowUserMenu: (value: boolean | ((prev: boolean) => boolean)) => void;
    userMenuRef: React.RefObject<HTMLDivElement>;
    onEditProfile: () => void;
    onLogout: () => void;
};

export default function Topbar({
    onStartPrint,
    org,
    showOrgMenu,
    setShowOrgMenu,
    orgDropdownRef,
    changeOrganization,
    currentUser,
    showUserMenu,
    setShowUserMenu,
    userMenuRef,
    onEditProfile,
    onLogout
}: TopbarProps) {
    return (
        <div className="topbar">
            <TopBarLeft />
            <TopbarRight
                onStartPrint={onStartPrint}
                org={org}
                showOrgMenu={showOrgMenu}
                setShowOrgMenu={setShowOrgMenu}
                orgDropdownRef={orgDropdownRef}
                changeOrganization={changeOrganization}
                currentUser={currentUser}
                showUserMenu={showUserMenu}
                setShowUserMenu={setShowUserMenu}
                userMenuRef={userMenuRef}
                onEditProfile={onEditProfile}
                onLogout={onLogout}
            />
        </div>
    );
}
